import React, { useState, useEffect } from 'react';
import FadeIn from './FadeIn';

function BurstShape() {
  return (
    <svg className="countdown__burst" viewBox="0 0 140 140" fill="none" xmlns="http://www.w3.org/2000/svg">
      {Array.from({ length: 12 }).map((_, i) => {
        const angle = (i * 30 * Math.PI) / 180;
        const cx = 70;
        const cy = 70;
        const r1 = 14;
        const r2 = 62;
        const x1 = cx + r1 * Math.cos(angle);
        const y1 = cy + r1 * Math.sin(angle);
        const x2 = cx + r2 * Math.cos(angle);
        const y2 = cy + r2 * Math.sin(angle);
        const len = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        const midX = (x1 + x2) / 2;
        const midY = (y1 + y2) / 2;
        const deg = (i * 30) + 90;
        return (
          <rect
            key={i}
            x={midX - 4}
            y={midY - len / 2}
            width="8"
            height={len}
            rx="3"
            fill="#FFB400"
            transform={`rotate(${deg}, ${midX}, ${midY})`}
            opacity="0.9"
          />
        );
      })}
    </svg>
  );
}

const TARGET = new Date('2026-10-10T09:00:00').getTime();

function useCountdown() {
  const calc = () => {
    const diff = Math.max(0, TARGET - Date.now());
    return {
      hours: Math.floor(diff / 3600000),
      minutes: Math.floor((diff % 3600000) / 60000),
      seconds: Math.floor((diff % 60000) / 1000),
    };
  };
  const [time, setTime] = useState(calc);
  useEffect(() => {
    const id = setInterval(() => setTime(calc()), 1000);
    return () => clearInterval(id);
  });
  return time;
}

const pad = (n) => String(n).padStart(2, '0');

export const tickets = [
  {
    type: 'EARLY BIRD DELEGATE',
    tag: 'Limited spots — secure yours now!',
    price: 'XAF 8,000',
    amount: 8000,
    featured: true,
  },
  {
    type: 'STANDARD DELEGATE',
    price: 'XAF 10,000',
    amount: 10000,
    featured: false,
  },
  {
    type: 'VIP EXPERIENCE',
    note: 'Includes gala dinner, front-row seating & speaker meetup',
    price: 'XAF 25,000',
    amount: 25000,
    featured: false,
  },
];

export default function Register() {
  const { hours, minutes, seconds } = useCountdown();

  const goToTickets = (ticketType) => {
    const params = new URLSearchParams({ ticket: ticketType });
    window.history.pushState({}, '', `/tickets?${params.toString()}`);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="register" id="tickets">
      <div className="container">
        <FadeIn>
        <div className="section-heading-row">
          <h2 className="section-heading-xl">REGISTER<br />NOW</h2>
          <div className="section-sub">
            Secure your delegate pass for LLC 2026 — Douala, Cameroon.
          </div>
        </div>
        </FadeIn>

        <FadeIn delay={1}>
        <div className="countdown-card">
          <div>
            <div className="countdown__label">Early Bird Pricing Ends In:</div>
            <div className="countdown__timer">
              <span className="countdown__num">{pad(hours)}</span>
              <span className="countdown__sep">:</span>
              <span className="countdown__num">{pad(minutes)}</span>
              <span className="countdown__sep">:</span>
              <span className="countdown__num">{pad(seconds)}</span>
            </div>
            <div className="countdown__units">
              <span className="countdown__unit-label">HOURS</span>
              <span className="countdown__unit-label">MINUTES</span>
              <span className="countdown__unit-label">SECONDS</span>
            </div>
          </div>
          <BurstShape />
        </div>
        </FadeIn>

        <FadeIn delay={2}>
        <div style={{ marginBottom: '32px' }}>
          <div className="tickets__title">Ticket Options</div>
          <div className="tickets__grid">
            {tickets.map((t) => (
              <div key={t.type} className={`ticket-card${t.featured ? ' ticket-card--featured' : ''}`}>
                <div className="ticket-card__type">{t.type}</div>
                {t.tag && <div className="ticket-card__tag">{t.tag}</div>}
                {t.note && <div className="ticket-card__note">{t.note}</div>}
                <div className="ticket-card__price">{t.price}</div>
                <button className="ticket-card__btn" type="button" onClick={() => goToTickets(t.type)}>
                  Get your ticket ↗
                </button>
              </div>
            ))}
          </div>
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
